import { instance as axios } from "@/store/_AXIOS"
import { _TOKEN, _DECODE } from "@/store/_JWT"

const TABLE = "/donativo/"

// initial state
const state = {
  data: []
}

// getters
const getters = {
  getAll: state => {
    return state.data
  },
  getById: state => id => {
    if (
      !id ||
      state.data.length == 0 ||
      typeof state.data.find(el => {
        return el.id_donativo == id
      }) == "undefined"
    )
      return "-"
    return state.data.find(el => {
      return el.id_donativo == id
    }).nome
  }
}

// actions
const actions = {
  get({ commit }, params) {
    return axios
      .get(TABLE)
      .then(res => {
        _DECODE(res.data.data).then(r => {
          if (r) commit("setData", r)
          else commit("setData", null)
        })
      })
      .catch(err => {
        commit("setData", null)
      })
  },

  getByInstituicao({ commit }, id) {
    return axios
      .post(TABLE + "params/" + _TOKEN({ id_instituicao: id }))
      .then(res => {
        _DECODE(res.data.data).then(r => {
          if (r) commit("setData", r)
          else commit("setData", null)
        })
      })
      .catch(err => {
        commit("setData", null)
      })
  },

  insert({ dispatch, rootState }, params) {
    return axios
      .post(TABLE + _TOKEN(params))
      .then(res => {
        dispatch("getByInstituicao", rootState.session.instituicao)

        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  },

  update({ dispatch, rootState }, params) {
    return axios
      .put(TABLE + _TOKEN(params))
      .then(res => {
        dispatch("getByInstituicao", rootState.session.instituicao)

        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  },

  delete({ dispatch, rootState }, params) {
    return axios
      .delete(TABLE + _TOKEN(params))
      .then(res => {
        dispatch("getByInstituicao", rootState.session.instituicao)

        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  }
}

// mutations
const mutations = {
  setData(state, data) {
    state.data = data ? data : []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
